const binding = { modules: {}, dataActions: {} };

    (binding.modules['gh-usp'] = {
        c: () => require('partner/modules/gh-usp/gh-usp.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'gh-usp',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/gh-usp'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|gh-usp|gh-usp'] = {
                c: () => require('partner/modules/gh-usp/gh-usp.view.tsx'),
                cn: '__local__-__local__-gh-usp'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };